(function () {
	const setupAccordion = () => {
		const wrapper = document.querySelector('[id="services-accordion-wrapper"]');
		if (!wrapper) {
			return;
		}
		let openFirst = wrapper.getAttribute('data-open-first');
		openFirst = openFirst && openFirst !== 'false';

		const accordionImages = Array.from(
			wrapper.querySelectorAll('[data-partial="image"]')
		);
		const accordionItems = Array.from(
			wrapper.querySelectorAll('.collapse')
		);
		const setupItem = (index, item, image) => {
			const $item = $(item);
			if (index !== 0) {
				image.setAttribute('hidden', true);
			} else if (openFirst) {
				$item.collapse('show');
			}
			$item.on('shown.bs.collapse', () => {
				image.removeAttribute('hidden');
				for (let i = 0; i < accordionImages.length; i++) {
					if (accordionImages[i] !== image) {
						accordionImages[i].setAttribute('hidden', true);
					}
				}
			});
		}
		for (let i = 0; i < accordionItems.length; i++) {
			setupItem(i, accordionItems[i], accordionImages[i]);
		}
	}

	onInteractive(setupAccordion);
	onComplete(() => {
		if (window.editor) {
			window.editor.addEventListener('reloaded', setupAccordion);
		}
	});

	// Wraps all &-characters with a class so the stylesheet can force these to use a different font with the preferred style of ampersand.
	onInteractive(() => {
		const walker = document.createTreeWalker(
			document.body,
			NodeFilter.SHOW_TEXT,
			{
				acceptNode (node) {
					if (!node.nodeValue.includes("&")) {
						return NodeFilter.FILTER_REJECT;
					}
					const parent = node.parentNode;
					if (parent && ["SCRIPT", "STYLE", "NOSCRIPT"].includes(parent.nodeName)) {
						return NodeFilter.FILTER_REJECT;
					}
					return NodeFilter.FILTER_ACCEPT;
				}
			}
		);

		const nodes = [];
		let current;

		while ((current = walker.nextNode())) {
			nodes.push(current);
		}

		nodes.forEach(node => {
			const parts = node.nodeValue.split("&");
			const fragment = document.createDocumentFragment();

			parts.forEach((part, index) => {
				if (index > 0) {
					const span = document.createElement("span");
					span.className = "alt-amp";
					span.textContent = "&";
					fragment.appendChild(span);
				}

				if (part.length > 0) {
					fragment.appendChild(document.createTextNode(part));
				}
			});

			node.parentNode.replaceChild(fragment, node);
		});
	})
}());